<template>
  <div class="container-fluid row">
    <div class="col-md-12 mb-3 mt-3" style="text-align: right">
      <a>
        <button type="button" id="get_file" class="btn btn-success btn-sm" @click="getid(0)" data-bs-toggle="modal"
          data-bs-target="#AddUser">
          <i class="fa fa-plus"></i> เพิ่มไฟล์ประกาศ
        </button></a>
    </div>
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px;">
      <table class="table table-bordered">
        <thead>
          <tr class="table-active">
            <th scope="col">ลำดับที่</th>
            <th scope="col">ปีการศึกษา</th>
            <th scope="col"> เทอม</th>
            <th scope="col"> ประเภทการสอบ</th>
            <th scope="col">ชื่อไฟล์</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody v-if="firstpagelist.length == 0">
        <td style="text-align: center;" colspan="6">ไม่พบข้อมูล</td> 
        </tbody>
      <tbody v-else>
          <tr v-for="(l, i) in firstpagelist" :key="i">
            <td>
              {{ i + 1 }}
            </td>
            <td>
              {{ l.year }}
            </td>
            <td>
              {{ l.term }}
            </td>
            <td>
              {{ l.exam_type }}
            </td>
            <td>{{ l.file_name }}</td>
            <td>
              <a @click="getid(l.id)">
                <button type="button" class="btn btn-warning btn-sm" data-bs-toggle="modal" data-bs-target="#AddUser">
                  <i class="fa fa-edit"></i></button></a>&nbsp;
              <!-- <a @click="deletedata(l.id)">
              <button
                type="button"
                class="btn btn-danger btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#DeleteStatus"
              >
                <i class="fa fa-trash"></i></button
            ></a> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="AddUser" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
            <button id="closeduser" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="card-body mt-3">
                <div class="form-group">
                  <label for="username">ปีการศึกษา</label>
                  <select v-model="firstpage.year" class="form-select form-control-sm" id="exampleFormControlSelect1" v-if="firstpage_id == 0">
              <option v-for="(s, i) in year" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
                  <input disabled v-model="firstpage.year" type="number" min="1" class="form-control form-control-sm"
                    id="year" v-else />
                </div>
                <div class="form-group mt-3">
                  <label for="exampleFormControlSelect1">เทอม</label>
                  <select v-model="firstpage.term" class="form-select form-control-sm" id="exampleFormControlSelect1"
                    v-if="firstpage_id == 0">
                    <option value="1">
                      1
                    </option>
                    <option value="2">
                      2
                    </option>
                  </select>
                  <select disabled v-model="firstpage.term" class="form-select form-control-sm"
                    id="exampleFormControlSelect1" v-else>
                    <option value="1">
                      1
                    </option>
                    <option value="2">
                      2
                    </option>
                  </select>
                </div>
                <div class="form-group mt-3">
                  <label for="exampleFormControlSelect1">ประเภทการสอบ</label>
                  <select v-model="firstpage.exam_type" class="form-select form-control-sm"
                    id="exampleFormControlSelect1" v-if="firstpage_id == 0">
                    <option value="M">
                      Midterm
                    </option>
                    <option value="F">
                      Final
                    </option>
                  </select>
                  <select disabled v-model="firstpage.exam_type" class="form-select form-control-sm"
                    id="exampleFormControlSelect1" v-else>
                    <option value="M">
                      Midterm
                    </option>
                    <option value="F">
                      Final
                    </option>
                  </select>
                </div>
                <div class="form-group mt-3">
                  <label for="exampleFormControlSelect1">เลือกไฟล์ประกาศ PDF</label>
                  <input type="file" accept="application/pdf" @change="onChangePDF" class="form-control-file" id="imagelist" />
                
    <iframe v-if="firstpage.file_path" class="mt-3"
    :src="`https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl)}&embedded=true`"
    style="width:100%; height:100vh; border:none;"
  ></iframe>
                </div>
                
              </div>
            </form>
          </div>
          <div class="modal-footer mt-3">
            <button type="button" class="btn btn-success btn-sm" @click="save()">
              บันทึก
            </button>
            <button type="button" class="btn btn btn-secondary btn-sm" data-bs-dismiss="modal">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="DeleteStatus" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">ยืนยันการลบข้อมูล</h5>
          </div>
          <div class="modal-footer mt-3">
            <button type="button" class="btn btn-danger btn-sm" @click="deletebyid()">
              <label>ลบข้อมูล</label>
            </button>
            <button id="closeddeleteuser" type="button" class="btn btn-secondary  btn-sm" data-bs-dismiss="modal">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/UserService";
import ProctorService from "../services/ProctorService";
import FacultyService from "../services/FacultyService";
import CourseService from "../services/CourseService";
import FirstPageService from "../services/FirstPageService";
import LinkService from "../services/LinkService";
import axios from 'axios';
import SubjectService from "../services/SubjectService";


export default {
  name: "Nav",
  props: {
    msg: String,
  },
  data() {
    return {
      concert_id: 0,
      list: [],
      user: {},
      user_id: 0,
      hash: 0,
      title: "",
      roles: [],
      delete_id: 0,
      proctor: [],
      faculty: [],
      instructor: {},
      firstpage: {},
      firstpage_id: 0,
      instructor_id: 0,
      courselist: [],
      course: [],
      firstpagelist: [],
      file: '',
      link:'',
      pdfUrl: '',
      year:[]
    };
  },
  mounted() {
    this.getRoles()
    this.getProctor()
    this.getFaculty();
    this.getCourse();
    this.getFirstPage();
    this.link = LinkService.getLink()
    this.getlistyear()
  },
  methods: {
    getlistyear(){
      const currentYear = new Date().getFullYear() + 543;
const startYear = 2565;

this.year = Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
  const year = startYear + i;
  return { id: year, name: year };
});

console.log(this.year);
    },
    onChangePDF(evt) {
      const files = evt.target.files || evt.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];

    },
    onUploadFileChange() {
      const formData = new FormData();
      formData.append("file", this.file);
      var name = this.firstpage.year + '_' + this.firstpage.term + '_' + this.firstpage.exam_type + '.pdf'
      console.log(name);

      var http = LinkService.getLink() + '/uploadimage?name=' + name;
      axios
        .post(http, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {
        })
    },
    getFirstPage() {
      FirstPageService.getFirstPages().then((res) => {
        this.firstpagelist = res.data
        console.log(this.firstpagelist);
      });

    },
    getCoursesByFaculty() {
      const courselist = this.course.filter(c =>
        c.faculty_id === this.filter.faculty_id
      );
      this.courselist = courselist;
    },
    getCourse() {
      CourseService.getCourses().then((res) => {
        this.course = res.data;
        this.courselist = res.data;
        console.log(res.data);
      });
    },
    getFaculty() {
      FacultyService.getFacultys().then((res) => {
        this.faculty = res.data;
        console.log(res.data);
      });
    },
    getProctor() {
      ProctorService.getProctors().then((res) => {
        this.proctor = res.data;
        console.log(res.data);
      });
    },
    deletedata(id) {
      this.delete_id = id;
    },
    getRoles() {
      UserService.getRolesAll().then((res) => {
        console.log(res.data);
        this.roles = res.data;
      });
    },
    getid(id) {
      this.firstpage_id = id;
      if (this.firstpage_id != 0) {
        this.title = "แก้ไขเอกสารประกาศตารางคุมสอบ";
        FirstPageService.getFirstPage(this.firstpage_id).then((res) => {
          this.firstpage = res.data;
          this.pdfUrl = LinkService.getLink() + this.firstpage.file_path
          console.log(this.pdfUrl);
          
        });
      } else {
        this.title = "เพิ่มเอกสารประกาศตารางคุมสอบ";
        this.firstpage = [];
      }
    },
    async GeneratePDF() {
      try {
        const res = await SubjectService.GeneratePDF(
          this.firstpage.year,
          this.firstpage.term,
          this.firstpage.exam_type
        );
        console.log("👥 GeneratePDF result:", res.data);
      } catch (error) {
        console.error("❌ Error assigning proctor:", error);
        throw error; // ให้ save() รู้ว่ามี error
      }
    },
    save() {
      if (this.firstpage.year == null) {
        alert("กรุณากรอกปีการศึกษา");
      } else if (this.firstpage.term == null) {
        alert("กรุณากรอกเทอม");
      } else if (this.firstpage.exam_type == null) {
        alert("กรุณาเลือกประเภทการสอบ");
      } else if (this.file == null || this.file == "") {
        alert("กรุณาเลือกไฟล์");
      } else {
        var file_name = this.firstpage.year + '_' + this.firstpage.term + '_' + this.firstpage.exam_type + '.pdf'

        var firstpagedata = {
          year: this.firstpage.year,
          term: this.firstpage.term,
          exam_type: this.firstpage.exam_type,
          file_path: '/template/' + file_name,
          file_name: file_name,
        };
        if (this.firstpage_id == 0) {
          this.onUploadFileChange()
          var status = this.firstpagelist.find(c => c.year === parseInt(this.firstpage.year) && c.term === parseInt(this.firstpage.term) && c.exam_type === this.firstpage.exam_type);
          console.log(status);
          console.log(this.firstpagelist);

          console.log(this.firstpage);

          if (!status) {
            FirstPageService.createFirstPage(firstpagedata).then(() => {
              // console.log(res.data);
              document.getElementById("closeduser").click();
              this.GeneratePDF()
            this.getFirstPage();
          });
          } else {

            var termType = this.firstpage.term === '1' ? 'ภาคการศึกษาต้น' : this.firstpage.term === '2' ? 'ภาคการศึกษาปลาย' : '';
            var examType = this.firstpage.exam_type === 'M' ? 'สอบกลางภาค' : this.firstpage.exam_type === 'F' ? 'สอบปลายภาค' : '';
            alert('ในระบบมีไฟล์ประกาศตารางควบคุมการ' + examType + ' ' + termType + ' ปีการศึกษา ' + this.firstpage.year + ' หากต้องการอัพเดตไฟล์ กรุณาทำการแก้ไขรายการในตาราง')
          }
        } else {
          this.onUploadFileChange()
          FirstPageService.updateFirstPage(this.firstpage_id, firstpagedata).then(() => {
            // console.log(res.data);
            document.getElementById("closeduser").click();
            this.GeneratePDF()
            this.getFirstPage();
          });
        }

      }
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}

.card {
  margin: 0 auto;
  /* Added */
  float: none;
  /* Added */
  margin-bottom: 10px;
  /* Added */
}

body {
  background-color: gray;
}
</style>
